import { Column } from 'react-table';

import { ActionsCell } from 'app/components/Table/columns/ActionsCell';
import { CustomHeader } from 'app/components/Table/columns/CustomHeader';
import { ActionTable, TYPE_MODAL } from 'app/components/Table/core/types';
import Typography from 'app/components/Typography';

import { isNil } from 'lodash';

import { Organizations } from './type';

export const organizationsRoleColumns = (
  handleRestoreOrg: (item: Organizations) => void,
): ReadonlyArray<Column<Organizations>> => {
  const actions = (item: Organizations) => {
    const isDeleted = !isNil(item.deletedAt);

    const listActions: ActionTable[] = [
      { name: 'Edit', type: TYPE_MODAL.EDIT },
      ...(isDeleted
        ? [{ name: 'Restore', type: TYPE_MODAL.NONE, onClick: handleRestoreOrg }]
        : [{ name: 'Delete', type: TYPE_MODAL.DELETE }]),
    ];
    return listActions;
  };

  return [
    {
      id: 'id',
      accessor: 'id',
      Header: (props) => <CustomHeader tableProps={props} title="ID" />,
      width: '10%',
      Cell: ({ ...props }) => {
        return (
          <Typography
            lineHeight={26}
            variant="body-1"
            style={{ opacity: !isNil(props.data[props.row.index].deletedAt) ? 0.3 : 1 }}
          >
            {`${props.data[props.row.index].id} `}
          </Typography>
        );
      },
    },
    {
      id: 'name',
      accessor: 'name',
      Header: (props) => <CustomHeader tableProps={props} title="Name" />,
      Cell: ({ ...props }) => {
        const isDeleted = !isNil(props.data[props.row.index].deletedAt);

        return (
          <p
            className="fw-normal"
            style={{
              whiteSpace: 'nowrap',
              maxWidth: 200,
              marginBottom: 0,
              opacity: isDeleted ? 0.3 : 1,
            }}
          >{`${props.data[props.row.index].name} ${isDeleted ? '(Deleted)' : ''}`}</p>
        );
      },
      width: '80%',
    },
    {
      id: 'actions',
      width: '5%',
      Header: (props) => (
        <CustomHeader tableProps={props} title="" className="text-end min-w-100px" />
      ),
      Cell: ({ ...props }) => (
        <ActionsCell
          item={props.data[props.row.index]}
          actions={actions(props.data[props.row.index])}
        />
      ),
    },
  ];
};
